import React, {useState, useEffect} from 'react';
import {PreguntaEncuesta} from './PreguntaEncuesta';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useNavigate} from 'react-router-dom';

export const ContentBodyEncuestas = () => {
	const encuesta = {
		titulo: 'Encuesta de satisfacion del cliente',
		descripcion:
			"Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero's ",
		isRecurrente: false,
		preguntas: [
			{
				id: 1,
				titlo: 'Pregunta spobre el producto 1 ',
				numeroMaximo: 5,
				obligatoria: true,
			},
			{
				id: 2,
				titlo: 'Pregunta si recomendaria el producto 2',
				numeroMaximo: 6,
				obligatoria: false,
			},
			{
				id: 3,
				titlo: 'Pregunta el tiempo de entrega 3',
				numeroMaximo: 4,
				obligatoria: false,
			},
		],
	};

	const [EncuestaEnviar, setEncuestaEnviar] = useState({
		preguntas: [],
	});

	const [ModalEnviarEncuesta, setModalEnviarEncuesta] = useState(false);

	const contestarPregunta = (id, respuesta) => {
		console.log(id, respuesta);
		let listaAxu = EncuestaEnviar.preguntas;
		listaAxu[id - 1].respuesta = respuesta;
		setEncuestaEnviar({
			preguntas: listaAxu,
		});
	};

	const crearEncuestaEnviar = () => {
		let listaAxu = EncuestaEnviar.preguntas;
		encuesta.preguntas.map((pregunta) => {
			listaAxu.push({
				id: pregunta.id,
				respuesta: 0,
			});
		});
		setEncuestaEnviar({
			preguntas: listaAxu,
		});
	};

	useEffect(() => {
		crearEncuestaEnviar();
	}, []);

	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();

	const enviarRespuestas = () => {
		//Desactivamos el modal
		setModalEnviarEncuesta(false);
		// ENVIAMOS LA RESPUESTA AL SERVIDOR A TRAVES DE LA API

		// y redireccionamos a la pagina de inicio
		navigate('/');
	};

	return (
		<>
			<Modal
				centered={true}
				isOpen={ModalEnviarEncuesta}
				toggle={() => setModalEnviarEncuesta(!ModalEnviarEncuesta)}
				className='modalEncuesta'
			>
				<ModalHeader>Encuesta terminada</ModalHeader>
				<ModalBody>
					<div className='centrador'>
						La encuesta se ha reazlizado correctamente, ¿desea enviarla ahora?
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => enviarRespuestas()}
						>
							<b>Enviar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<div className='ContentEncuesta'>
				<div className='headEncuesta'>
					<div className='contentHeadEncuesta'>
						<h1>{encuesta.titulo}</h1>
						<p>{encuesta.descripcion}</p>
					</div>
				</div>
				<div className='listaPreguntas'>
					{encuesta.preguntas.map((pregunta) => (
						<PreguntaEncuesta
							key={pregunta.id}
							Id={pregunta.id}
							titlo={pregunta.titlo}
							numeroMaximo={pregunta.numeroMaximo}
							obligatoria={pregunta.obligatoria}
							contestarPregunta={contestarPregunta}
						/>
					))}
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalEnviarEncuesta(!ModalEnviarEncuesta)}
						>
							<b>Enviar</b>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
